import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin } from 'Util';
import { StoreOverviewStore, StripeStore, AuthStore } from 'stores';
import StripeCheckoutForm from 'components/Store/StripeCheckoutForm';
import { getCart } from 'selectors/store';

class StripeCheckoutFormContainer extends mixin(RefluxMixin, Component) {
  listenToStores() {
    this.listenToStoreWithMapper(StripeStore, state => ({
      ...state
    }));

    this.listenToStoreWithMapper(AuthStore, state => ({
      loggedIn: state.loggedIn
    }));

    this.listenToStoreWithMapper(StoreOverviewStore, state => ({
      errorText: state.payment.errorText,
      secure3DUrl: state.payment.data.url,
      error: state.payment.data.error,
      paymentLoading: state.payment.loading,
      cart: getCart(state)
    }));
  }

  render() {
    return <StripeCheckoutForm {...this.state} {...this.props} />;
  }
}

export default StripeCheckoutFormContainer;



// WEBPACK FOOTER //
// ./src/js/containers/Store/StripeCheckoutForm.js